// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
// @skip-file-minify
// ##############################################################
// AUTO GENERATED FILE: This file is Auto Generated during build.
// ##############################################################
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// Note: DON'T Export these const from the package as we are still targeting ES3 this will export a mutable variables that someone could change!!!
// !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
export var _DYN_FEATURE_OPT_IN = "featureOptIn"; // Count: 4
export var _DYN_ON_CFG_CHANGE_RECEIV0 = "onCfgChangeReceive"; // Count: 2
export var _DYN_NON_OVERRIDE_CONFIGS = "nonOverrideConfigs"; // Count: 2
export var _DYN_SCHEDULE_FETCH_TIMEO1 = "scheduleFetchTimeout"; // Count: 2
//# sourceMappingURL=__DynamicConstants.js.map